import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AreaCard from "./AreaCard";
import Sidebar from "../../../components/sidebar";
import Projects from "../../../components/projects";
import Users from "../../../components/users";
import Profile from "../../../components/profile";
import KanbanBoard from "../../../components/kanban_board";
import Settings from "../../../components/settings";
import Dashboard from "../../../components/dashboard";
import ContasWilder from "../../projects_t_engineering/ContasWilder/ContasWilder";
import InternRegisterUser from '../../inter_register_user';
import UserIntern from "../../../pages/user_intern";
import { setAreas } from "../../../store/modules/area/actions";
import {
  SearchSection,
  MainContainer,
  BackgroundPattern,
  SideContainer,
  ContentWrapper,
  HeaderSection,
  Title,
  Subtitle,
  SearchContainer,
  SearchBox,
  SelectStyled,
  InputStyled,
  AreaListWrapper,
  ButtonContainerLeft,
  ButtonContainerRight,
  ButtonRow,
  StyledButton,
} from "./styles";
import { guardianAreaService } from "../../../services/guardianAreaService";
import { goToGuardianHub } from "../../../utils/appNavigation";

const ListAreas = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const collapsed = useSelector((state) => state.sidebar);
  const [allAreas, setAllAreas] = useState([]);
  const [filteredAreas, setFilteredAreas] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [selectedColumn, setSelectedColumn] = useState("Nome");
  const app_status = useSelector((state) => state.app_status.status);
  const location = useLocation();
  const user = location?.state?.user;

  const handleCancel = () => {
    goToGuardianHub(dispatch, navigate);
  };

  useEffect(() => {
    const fetchAllAreas = async () => {
      try {
        const data = await guardianAreaService.getGuardianAreas();
        const list = Array.isArray(data) ? data : [];
        setAllAreas(list);
        setFilteredAreas(list);
        dispatch(setAreas(list));
      } catch (error) {
        console.error("❌ Erro ao buscar áreas:", error);
      }
    };

    fetchAllAreas();
  }, [dispatch]);

  useEffect(() => {
    const fetchFilteredAreas = async () => {
      if (!searchValue) {
        setFilteredAreas(allAreas);
        return;
      }

      try {
        const data = await guardianAreaService.getFilterGuardianAreas(
          selectedColumn,
          searchValue
        );
        setFilteredAreas(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("❌ Erro ao filtrar áreas:", error);
      }
    };

    fetchFilteredAreas();
  }, [searchValue, selectedColumn, allAreas]);

  return (
    <MainContainer collapsed={collapsed}>
      <BackgroundPattern />
      <Sidebar />
      <SideContainer>
        {
          app_status === 'Projetos' ? <Projects /> :
            app_status === 'Usuários' ? <Users /> :
              app_status === 'Meu Perfil' ? <Profile /> :
                app_status === "Desenvolvimento" ? <KanbanBoard /> :
                  app_status === "Configurações" ? <Settings /> :
                    app_status === "cad_new_user" ? <InternRegisterUser userType={location.state?.userType} /> :
                      app_status === "edit_user" ? <UserIntern user={user} /> :
                        app_status === "Dashboard" ? <Dashboard /> :
                          app_status === "Contas" ? <ContasWilder /> :
                            (
                              <ContentWrapper>
                                <ButtonRow>
                                  <ButtonContainerLeft>
                                    <StyledButton onClick={handleCancel}>
                                      Voltar
                                    </StyledButton>
                                  </ButtonContainerLeft>

                                  <ButtonContainerRight>
                                    <StyledButton
                                      onClick={() => {
                                        navigate("/archived_areas");
                                      }}
                                    >
                                      <span style={{ marginRight: "8px" }}>📁</span>
                                      Ver Áreas Arquivadas
                                    </StyledButton>
                                  </ButtonContainerRight>
                                </ButtonRow>

                                <HeaderSection>
                                  <Title>Áreas de Interesse</Title>
                                  <Subtitle>
                                    Áreas agrupadas por projeto. Áreas FIRMS ficam nos detalhes de cada área.
                                  </Subtitle>
                                </HeaderSection>

                                <SearchSection>
                                  <SearchContainer>
                                    <SearchBox>
                                      <SelectStyled
                                        value={selectedColumn}
                                        onChange={(e) => setSelectedColumn(e.target.value)}
                                      >
                                        <option value="Nome">Nome</option>
                                        <option value="Projeto">Projeto</option>
                                        <option value="Responsável">Gestor</option>
                                      </SelectStyled>

                                      <InputStyled
                                        type="text"
                                        placeholder={`Pesquisar por ${selectedColumn === "Responsável" ? "Gestor" : selectedColumn}...`}
                                        value={searchValue}
                                        onChange={(e) => setSearchValue(e.target.value)}
                                      />
                                    </SearchBox>
                                  </SearchContainer>
                                </SearchSection>

                                <AreaListWrapper>
                                  <AreaCard filteredAreas={filteredAreas} />
                                </AreaListWrapper>
                              </ContentWrapper>
                            )}
      </SideContainer>
    </MainContainer >
  );
};

export default ListAreas;
